const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const DynamicRequestQuery: any = {
    GetRequest: Backofficebff + '/v1/dynamicrequest/getrequest',
};
